import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MarkdownElement from '@material-ui/docs/MarkdownElement';
import { withStyles } from '@material-ui/core/styles';
import DownloadsTable from './downloadsTable.js';
import VdeDatasetViewerDownloadsTable from '../vde-dataset-viewer/downloads/vdeDatasetViewerDownloadsTable.js';
import Button from '@material-ui/core/Button';
/* eslint import/no-webpack-loader-syntax: off */
import downloadsPre from '!raw-loader!./downloadsPre.md';
import downloadsPost from '!raw-loader!./downloadsPost.md';
import vdeDatasetViewerPre from '!raw-loader!../vde-dataset-viewer/downloads/vdeDatasetViewerPre.md';
import vdeDatasetViewerPost from '!raw-loader!../vde-dataset-viewer/downloads/vdeDatasetViewerPost.md';

const styles = theme => ({
    root: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing.unit * 3,
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '200px',
    },
});


function Downloads(props) {
    const { classes } = props;
    const [selectedApp, setSelectedApp] = useState('dataset-viewer');

    const handleAppSelection = (app) => {
        setSelectedApp(app);
    };

    return (
        <div className={classes.root}>
            <div className={classes.buttonsContainer}>
                <Button 
                    variant={selectedApp === 'define-xml' ? 'contained' : 'outlined'} 
                    color="primary"
                    className={classes.button}
                    onClick={() => handleAppSelection('define-xml')}
                >
                    Visual Define-XML Editor
                </Button>
                <Button 
                    variant={selectedApp === 'dataset-viewer' ? 'contained' : 'outlined'} 
                    color="primary"
                    className={classes.button}
                    onClick={() => handleAppSelection('dataset-viewer')}
                >
                    VDE Dataset Viewer
                </Button>
            </div>

            {selectedApp === 'define-xml' ? (
                <>
                    <MarkdownElement text={downloadsPre} />
                    <DownloadsTable 
                        currentVersion={props.currentVersion} 
                        currentStableVersion={props.currentStableVersion}
                    />
                    <MarkdownElement text={downloadsPost} />
                </>
            ) : (
                <>
                    <MarkdownElement text={vdeDatasetViewerPre} />
                    <VdeDatasetViewerDownloadsTable currentVersion={props.currentViewerVersion} />
                    <MarkdownElement text={vdeDatasetViewerPost} />
                </>
            )}
        </div>
    );
}

Downloads.propTypes = {
    classes: PropTypes.object.isRequired,
    currentVersion: PropTypes.string.isRequired,
};

export default withStyles(styles)(Downloads);
